module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_75000_100000.2857d7be.png";